module.exports = {"id":"187702","name":"Omar El Kaddouri","rating":"76","photo":"./data/images/photos/0/187702.png","club":{"name":"PAOK Salonique","logo":"./data/images/clubs/PAOKSalonique.png"},"positions":["MOC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmarElKaddouri0.json
// module id = 3277
// module chunks = 0